<template>
    <el-card shadow="never" class="fundation-loader" :class="{'dark-el-card': dark}">
        <div class="ns-loading-overlay">
            <div class="ring-container">
                <div class="lds-ring">
                    <p>{{ getVerbose('ns_loader_loading') }}</p>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {
        dark: {
            type: Boolean,
            default: false,
        },
    },

    data (){
        return {

        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">
.fundation-loader{
    position: relative;
    height: 400px;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/fundation-loader.vue